<script setup lang="ts">
import { defineEmits, defineProps } from "vue";
import { useTranslate } from "@/composables/useTranslate";

type Props = {
  isReportDialogOpen: boolean;
  bonusReportDate: string;
};

const props = defineProps<Props>();

type Emits = {
  (event: "onClose"): void;
};

const emits = defineEmits<Emits>();
const { t } = useTranslate();

const handleClose = () => {
  emits("onClose");
};
</script>
<template>
  <Transition name="nested">
    <div class="w-full h-screen fixed top-0 left-0 bg-black/75 z-[1000]">
      <div
        class="w-full max-w-[854px] min-h-[316px] px-[20px] fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 rounded-[7px] bg-white z-[1000]"
      >
        <div
          class="flex items-center justify-between py-[16px] mb-[16px] border-b border-[#E3E1EA]"
        >
          <div class="flex items-center">
            <img
              class="w-[24px] h-[24px]"
              src="@/assets/Clipboard_Check.svg"
              alt=""
            />
            <p class="ml-[8px] text-[20px] font-semibold text-[#393840]">
              {{ bonusReportDate }}
            </p>
          </div>
          <img
            class="h-[12px] w-[12px] cursor-pointer"
            src="@/assets/close-icon-2.svg"
            alt=""
            @click="handleClose()"
          />
        </div>

        <div
          class="max-h-[400px] py-[40px] flex flex-col items-center border-b border-[#E3E1EA] rounded-tl-[7px]"
        >
          <img
            class="h-[60px] w-[60px] mb-[20px]"
            src="@/assets/star-icon.svg"
            alt=""
          />
          <p
            class="min-w-[272px] text-center text-[24px] font-bold text-[#393840] leading-[26px]"
          >
            {{ t("installers.report_upload_success") }}
          </p>
        </div>

        <div class="py-[12px] flex items-center justify-end">
          <button
            @click="handleClose()"
            class="w-[150px] flex items-center justify-center p-[12px] gap-[8px] text-[16px] text-white font-semibold border-2 border-[#393840] rounded-[7px]"
          >
            <span class="text-[#393840]">{{ t("global.close") }}</span>
          </button>
        </div>
      </div>
    </div>
  </Transition>
</template>
